import styled from 'styled-components';
import { LogOut } from 'styled-icons/feather/LogOut';
import { StyledIconBase } from '@styled-icons/styled-icon';
import { ArrowIconOutline } from '../Icons';

export const Container = styled.div`
  z-index: 5;
  position: fixed;
  top: 26px;
  right: 30px;
  &.active-menu {
    z-index: 6;
  }

  display: flex;
  align-items: center;  
  color: ${(props) => props.theme.colors.text.default};
  transition: 0.2s linear;  
  &:hover {
    cursor: pointer;
  }  
  .active:first-of-type {
    transform: rotate(-90deg);
    transition: 0.2s linear;
  }

  .noActive {
    transform: rotate(0deg);
    transition: 0.2s linear;
  }

  .menuItem:last-of-type {
    border-radius: 0 0 15px 15px;
    border-bottom: 0px;
  }
  @media (max-width: 586px) {
    top: 21px;
    right: 12px;
  }
`;

export const Name = styled.span`
  color: ${(props) => props.theme.colors.headerName};
  font-size: 1.4rem;
  margin-right: 10px;
  font-weight: 400;
`;

export const Image = styled.div`
  display: block;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid ${(props) => props.theme.colors.avataBorderColor};
  background-image: ${(props) => (props.background ? `url(${props.background})` : '')};
  background-size: cover;
  background-position: center center;

  @media (max-width: 586px) {
    width: 40px;
    height: 40px;    
  }
`;

export const OpenMenuImage = styled.div`
  display: block;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid ${(props) => props.theme.colors.avataBorderColor};
  background-image: ${(props) => (props.background ? `url(${props.background})` : '')};
  background-size: cover;
  background-position: center center;

  @media (max-width: 586px) {
    width: 35px;
    height: 35px;
  }
`;

export const ArrowDownIcon = styled(ArrowIconOutline)`
  width: 20px;
  height: 20px;
  color:#FFFFFF;
  @media (max-width: 586px) {
    // padding-left:20px;
  }
`;

export const Menu = styled.div`
  position: absolute;
  display: flex;
  z-index: 11;
  flex-direction: column;
  background-color: ${(props) => props.theme.colors.avataBackgroundColor};
  border-radius:15px 15px 20px 20px;
  width: 257px;  
  box-shadow: 0px 4px 4px ${(props) => props.theme.colors.avataShadowColor};
  opacity: 0;  
  top: 15px;
  left: 290px;
  visibility: hidden;  
  transition: all 0.2s linear;
  
  &.active {
    opacity: 1;
    left: -176px;
    top: -7px;    
    visibility: visible;
    z-index: 99999999;
    @media (max-width: 586px) {
      position: fixed;
      left: 0;
      top: 0;
      min-width: auto;
      width: 100vw;
      height: 100vh;
      max-height: 100vh;      
      padding: 10px;
      visibility: visible;
      transition: all 0.2s linear 0s;
      border-radius: 0px;
    }
  }
`;

export const MenuItem = styled.span`
{
  font-size: 16px;
  color: ${(props) => ((props.color) ? props.color : props.theme.colors.menuItemTextColor)};
  background-color: ${(props) => props.theme.colors.menuItem};
  padding: ${(props) => props.padding};
  border-radius: ${(props) => props.radius};
  transition: color 0.2s linear;
  display: flex;
  align-items: center;
  text-transform: capitalize;
  font-weight: ${(props) => props.fontWeight};
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  color: ${(props) => (props.disabled ? props.theme.colors.disabledMenuItem : '')};
  .icon {
    fill:${(props) => (props.disabled ? props.theme.colors.disabledMenuItem : props.theme.colors.menuIconTextColor)};  
    transition: color 0.2s linear;
    margin-right: 5px;   
  }
  @media (max-width: 586px) {
    .icon{
      fill:${(props) => (props.disabled ? props.theme.colors.disabledMenuItem : props.theme.colors.menuMobileIconTextColor)};
    }
    color: ${(props) => (props.disabled ? props.theme.colors.disabledMenuItem : 'white')};    
    background-color: ${(props) => props.theme.colors.avataBackgroundColor};
    height: 70px;    
  }

  &:hover {
    color: ${(props) => (props.disabled ? 'default' : '#10c2c5')};
    cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};

    .icon {
      color: #10c2c5;
    }
  }
  #tooltip{
    color: ${(props) => props.theme.colors.tooltipTextColor};    
    background-color: ${(props) => props.theme.colors.tooltipBackgroundColor};    
    border: 1px solid ${(props) => props.theme.colors.tooltipBorderColor};
    width: 200px;
    box-sizing: border-box;
    border-radius: 10px;    
  }
}
`;
export const MobileHeader = styled.div`  
  justify-content: space-between;
  padding:15px 20px;
  height:65px;
  border-radius:15px 15px 0 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  .user-identifier-wrapper {
    display: flex;
    align-items: center;
  }

  .user-greetings {
    color: #fff;
    display: flex;
    flex-direction: column;
    font-size: 12px;

    .greetings {
      text-align: left;
      font-weight: bold;
      margin-bottom: 2px;
    }    
    margin-left: 10px;
  }    

    .settings-closer {
      color: #fff;
      font-size: 35px;
      font-weight: normal;
      display: block;
      cursor: pointer;
      
      margin-right:5px;
    }  
`;

export const IconStyleWrapper = styled.div`
  ${StyledIconBase} {
    color: #610082;
    width: 20px;
    height: 20px;
    transition: color 0.2s linear;
  }
  line-height: 1;
`;

export const ContainerMenuItems = styled.div`
`;
export const LogOutIcon = styled(LogOut)``;
